import React, { useEffect, useMemo, useState } from "react";


export default function ReportViewer() {

    var url = localStorage.getItem("ReportURL");
    const [reloadURL, setReloadURL] = useState<number>(0);

    const MINUTE_MS = 300000;

    useEffect(() => {
        const interval = setInterval(() => {
            
            var randomNumber = Math.random() + 1;

            return setReloadURL(randomNumber);
        }, MINUTE_MS);

        // return () => {
        //     setReloadDashboard(true)
        //     clearInterval(interval);
        // }
    }, []);


    return (

        <div style={{ height: "100%", width: "100%" }}>
            <iframe key={reloadURL} style={{ height: "100%", width: "100%" }} src={url!}>

            </iframe>
        </div>
    );
};
